import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { AppComponent } from "./app.component";
import { DxHttpModule } from "devextreme-angular/http";
import {
  SideNavOuterToolbarModule,
  SideNavInnerToolbarModule,
  SingleCardModule,
} from "./layouts";
import {
  FooterModule,
  ResetPasswordFormModule,
  CreateAccountFormModule,
  ChangePasswordFormModule,
  LoginFormModule,
} from "./shared/components";
import { AuthService, ScreenService, AppInfoService } from "./shared/services";
import { UnauthenticatedContentModule } from "./unauthenticated-content";
import { AppRoutingModule } from "./app-routing.module";
import { NestedOptionHost } from "devextreme-angular/core";
import { DxDataGridModule, DxLoadPanelModule, DxTextBoxModule } from "devextreme-angular";
import { FormsModule } from "@angular/forms";
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from "@angular/common/http";
import config from "devextreme/core/config";
import { LoginTokenInterceptor } from "./LoginTokenInterceptor";
import { NgxMaskDirective, provideNgxMask } from "ngx-mask";
import { NotificationComponent } from './shared/components/notification/notification.component';

// ← Add these two imports
import { TranslateModule } from "@ngx-translate/core";
import { provideTranslateHttpLoader } from "@ngx-translate/http-loader";


@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    DxHttpModule,
    SideNavOuterToolbarModule,
    SideNavInnerToolbarModule,
    SingleCardModule,
    FooterModule,
    ResetPasswordFormModule,
    CreateAccountFormModule,
    ChangePasswordFormModule,
    LoginFormModule,
    UnauthenticatedContentModule,
    AppRoutingModule,
    DxTextBoxModule,
    DxDataGridModule,
    NgxMaskDirective,
    FormsModule,
    HttpClientModule,
    DxLoadPanelModule,

    // ← Add this block
    TranslateModule.forRoot({
      defaultLanguage: 'en',
    }),
  ],
  providers: [
    provideNgxMask(),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoginTokenInterceptor,
      multi: true,
    },
    AuthService,
    ScreenService,
    AppInfoService,
    NestedOptionHost,

    ...provideTranslateHttpLoader({
      prefix: './assets/i18n/',
      suffix: '.json',
    }),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor() {
    config({
      licenseKey:
        "ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogImY3NTJjZmMxLWIyYWItNDAwNy04MTc1LWMwMDI1MDMzYzM3YSIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjQyCn0=.q7DD8pGcqcJT9mUn7pltP9f9k9nLLG+TCRojXsDhAPghVaHeY7bHKcn1OWvcwBG3MzO7bcZuGLEeKzYbbo1aIIqZnNBYdm8sdhRSHbxP8CuzaYvfuUmfjcMeZFYZ1KIgGFpzLQ==",
    });
  }
}
